import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '_helpers';
import { alertActions } from './alert.slice';

const name = 'diagnosticLogger';
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports
export const diagnosticLoggerActions = { ...slice.actions, ...extraActions };
export const diagnosticLoggerReducer = slice.reducer;

// implementation
function createInitialState() {
    return {
        logs: null,
        vins: null,
        isLoading: false,
        error: null,
    };
}

function createReducers() {
    return {
        clearLogs,
        clearVins
    };

    function clearLogs(state){
        state.logs = null;
    }

    function clearVins(state){
        state.vins = null;
    }
}

function createExtraActions() {
    const baseUrl = process.env.REACT_APP_API_URL;

    return {
        getData: getData(),
        getVins: getVins()
    };

    function getData() {
        return createAsyncThunk(
            `${name}/getData`,
            async function (vin, { dispatch }) {
                try {
                    const data = await fetchWrapper.get(`${baseUrl}/diagnostic_logger?vin=${vin}`)
                    //dispatch(alertActions.success({message: 'Actualisation des données diagnostic logger', showAfterRedirect: true}))
                    return data;
                }catch (error) {
                    const message = error ?? "Erreur lors de l'acualisation des données diagnostic logger";
                    dispatch(alertActions.error({message: message, showAfterRedirect: true}));
                }
            
            }
        );
    }

    function getVins() {
        return createAsyncThunk(
            `${name}/getVins`,
            async function (vin, { dispatch }) {
                try {
                    const data = await fetchWrapper.get(`${baseUrl}/diagnostic_logger_vin`)
                    //dispatch(alertActions.success({message: 'Actualisation des données data collector', showAfterRedirect: true}))
                    return data;
                }catch (error) {
                    const message = error ?? "Erreur lors de l'acualisation des données diagnostic logger vins";
                    dispatch(alertActions.error({message: message, showAfterRedirect: true}));
                }
            
            }
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        getData();
        getVins();

        function getData() {
            const { pending, fulfilled, rejected } = extraActions.getData;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.logs = action.payload;
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.error.message || 'Echec de récupération des logs';
                });
        }

        function getVins() {
            const { pending, fulfilled, rejected } = extraActions.getVins;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.vins = action.payload;
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.error.message || 'Echec de récupération des logs';
                });
        }
    };
}

export default diagnosticLoggerReducer;
